import { render } from "./TestApp.vue?vue&type=template&id=b859d312"
import script from "./TestApp.vue?vue&type=script&lang=js"
export * from "./TestApp.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__